// ** Types
import type { SxProps, Theme } from '@mui/material/styles';
import type { UploadFile } from '@/types/graphql';
import type { CardCarouselCardsPerView } from '@/components/common/carousel/CardCarousel';

// ** Components
import MediaCard from './MediaCard';
import CardCarousel from '@/components/common/carousel/CardCarousel';

export type MediaCarouselItem = {
	documentId: string;
	type: string;
	title: string;
	description?: string | null;
	imageData?: UploadFile | null;
	imageUrl?: string | null;
	host: string;
	slug: string;
	publishedAt?: string | null;
	typeLabel?: string | null;
	ctaLabel?: string;
	basePath: string;
};

export type MediaCarouselProps = {
	items: MediaCarouselItem[];
	title?: string;
	showTitle?: boolean;
	ctaLabel?: string;
	ctaHref?: string;
	showCta?: boolean;
	cardsPerView?: CardCarouselCardsPerView;
	showArrowControls?: boolean;
	prevAriaLabel?: string;
	nextAriaLabel?: string;
	sx?: SxProps<Theme>;
	basePath?: string;
};

const MediaCarousel = ({
	items,
	title = 'Aktuelle News',
	showTitle = false,
	ctaLabel = 'Alle News',
	ctaHref,
	showCta = false,
	cardsPerView = { xs: 1.2, md: 3.2 },
	showArrowControls = true,
	prevAriaLabel = 'Vorherige News',
	nextAriaLabel = 'Naechste News',
	sx
}: MediaCarouselProps) => (
	<CardCarousel
		items={items}
		getItemKey={(card) => card.documentId}
		cardsPerView={cardsPerView}
		renderItem={(card) => (
			<MediaCard
				type={card.type}
				title={card.title}
				description={card.description}
				imageData={card.imageData}
				imageUrl={card.imageUrl}
				host={card.host}
				slug={card.slug}
				publishedAt={card.publishedAt}
				typeLabel={card.typeLabel}
				ctaLabel={card.ctaLabel}
				basePath={card.basePath}
				fluidWidth
			/>
		)}
		title={title}
		showTitle={showTitle}
		ctaLabel={ctaLabel}
		ctaHref={ctaHref}
		showCta={showCta}
		spaceBetween={4}
		indicatorCount={3}
		showArrowControls={showArrowControls}
		prevAriaLabel={prevAriaLabel}
		nextAriaLabel={nextAriaLabel}
		sx={sx}
	/>
);

export default MediaCarousel;
